var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24,
    rx: 4,
    fill: "#D84747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97 17h-1.8V7.2h3.74c1.64 0 3.48.91 3.48 3.18s-1.84 3.2-3.48 3.2H8.97V17Zm0-8.19v3.16h1.78c1.37 0 1.83-.72 1.83-1.6 0-.85-.46-1.56-1.83-1.56H8.97ZM19.94 17H16.1V7.2h3.84a4.78 4.78 0 0 1 4.96 4.9c0 2.86-2.13 4.9-4.96 4.9ZM17.9 8.81v6.58h2.04c1.96 0 3.15-1.46 3.15-3.29s-1.19-3.29-3.15-3.29H17.9ZM28.45 17h-1.8V7.2h6.92v1.58l-5.12-.01v2.5h5v1.59h-5V17Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPdf);
export default __webpack_public_path__ + "static/media/tag-pdf.229296be516975afd48335f8fa0df7ce.svg";
export { ForwardRef as ReactComponent };